import { createAction } from 'redux-actions';

export const APP_WORKSPACE_MENU_IS_OPEN_SET = 'APP_WORKSPACE_MENU_IS_OPEN_SET';

export default createAction(APP_WORKSPACE_MENU_IS_OPEN_SET);
